import { render, staticRenderFns } from "./ChangePreviousStageLink.vue?vue&type=template&id=1cbac6e2&scoped=true&"
import script from "./ChangePreviousStageLink.vue?vue&type=script&lang=js&"
export * from "./ChangePreviousStageLink.vue?vue&type=script&lang=js&"
import style0 from "./ChangePreviousStageLink.vue?vue&type=style&index=0&id=1cbac6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbac6e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
